import React from 'react';
import ListadoLote from '../../components/clasificacion/ListadoLote';



const ListadoLotes: React.FC = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
      <ListadoLote />


    </div>
  );
};

export default ListadoLotes;